import { render, staticRenderFns } from "./NotizModal.vue?vue&type=template&id=dbb122bc&scoped=true"
import script from "./NotizModal.vue?vue&type=script&lang=js"
export * from "./NotizModal.vue?vue&type=script&lang=js"
import style0 from "./NotizModal.vue?vue&type=style&index=0&id=dbb122bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb122bc",
  null
  
)

export default component.exports